import { render } from "./Dashboard-PTJ.vue?vue&type=template&id=5c35f03f"
import script from "./Dashboard-PTJ.vue?vue&type=script&lang=js"
export * from "./Dashboard-PTJ.vue?vue&type=script&lang=js"

import "./Dashboard-PTJ.vue?vue&type=style&index=0&id=5c35f03f&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__